const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.GADGETS_WAREHOUSE_STATUSES)

export const apiGadgetsWarehouseStatuses = {
	fetchGadgetsWarehouseStatuses: async (
		search: IApiSearch = { query: '' },
		pagination: IApiPagination = { page: 1, perPage: 25 },
		filters?: IApiFilters,
	): Promise<IApiResponseModel<IGadgetsWarehouseStatusModel[]>> => {
		const searchFilter = createSearchQuery(search.query, search.type)

		const { data, meta } = await apiCommon<IGadgetsWarehouseStatus[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(pagination, { ...filters, ...searchFilter }),
		})

		return { data: data.map(GadgetsWarehouseStatus), meta }
	},
	fetchGadgetsWarehouseStatusDetails: async (id: number): Promise<IGadgetsWarehouseStatusModel> => {
		const { data } = await apiCommon<IGadgetsWarehouseStatus>(`${groupPrefix}/${id}`, {
			method: 'GET',
		})

		return GadgetsWarehouseStatus(data)
	},
	manageGadgetsWarehouseStatus: async (
		payload: IGadgetsWarehouseStatusPayload,
	): Promise<IGadgetsWarehouseStatusModel> => {
		const { data } = await apiCommon<IGadgetsWarehouseStatus>(`${groupPrefix}/${payload.gadget_id}`, {
			method: 'POST',
			body: payload,
		})

		return GadgetsWarehouseStatus(data)
	},
	deleteGadgetsWarehouseStatus: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, {
			method: 'DELETE',
		})
	},
}
